import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { MessageSquare } from "lucide-react";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { AppointmentModal } from "./components/common/AppointmentModal";
import { WhatsAppButton } from "./components/common/WhatsAppButton";
import HomePage from "./pages/HomePage";
import IndividualServicePage from "./pages/IndividualServicePage";
import AboutPage from "./pages/AboutPage";
import PartnerPage from "./pages/PartnerPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import InsightsPage from "./pages/InsightsPage";
import ArticlePage from "./pages/ArticlePage";

function MainLayout({ children, onOpenAppointment }) {
  return (
    <>
      <Navbar onOpenAppointment={onOpenAppointment} />
      {children}
      <Footer onOpenAppointment={onOpenAppointment} />
    </>
  );
}

// 301 Redirect component for old URLs
function OldURLRedirect() {
  const { category, slug } = useParams();
  return <Navigate to={`/${slug}`} replace />;
}

function MobileStickyButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === "/") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    } else if (location.pathname.startsWith("/services/")) {
      const el = document.getElementById("svc-contact") || document.getElementById("ind-contact");
      el?.scrollIntoView({ behavior: "smooth" });
    } else {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return null;
}

function App() {
  const [appointmentOpen, setAppointmentOpen] = useState(false);
  const openAppointment = () => setAppointmentOpen(true);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppointmentModal open={appointmentOpen} onClose={() => setAppointmentOpen(false)} />
        <WhatsAppButton />
        <MobileStickyButton />
        <Routes>
          <Route path="/" element={<MainLayout onOpenAppointment={openAppointment}><HomePage onOpenAppointment={openAppointment} /></MainLayout>} />

          {/* 301 Redirect: Old category URLs to home */}
          <Route path="/services/compliance" element={<Navigate to="/" replace />} />
          <Route path="/services/it" element={<Navigate to="/" replace />} />
          <Route path="/services/supplies" element={<Navigate to="/" replace />} />
          <Route path="/services/manpower" element={<Navigate to="/" replace />} />

          {/* 301 Redirect: Old service URLs to new format */}
          <Route path="/services/:category/:slug" element={<OldURLRedirect />} />

          {/* Info pages */}
          <Route path="/about" element={<MainLayout onOpenAppointment={openAppointment}><AboutPage /></MainLayout>} />
          <Route path="/partner" element={<MainLayout onOpenAppointment={openAppointment}><PartnerPage /></MainLayout>} />
          <Route path="/privacy-policy" element={<MainLayout onOpenAppointment={openAppointment}><PrivacyPolicyPage /></MainLayout>} />
          <Route path="/terms" element={<MainLayout onOpenAppointment={openAppointment}><TermsPage /></MainLayout>} />
          <Route path="/refund-policy" element={<MainLayout onOpenAppointment={openAppointment}><RefundPolicyPage /></MainLayout>} />

          {/* Insights/Articles pages */}
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<ArticlePage />} />

          {/* Individual service pages - NEW URL FORMAT (/:slug) - MUST BE LAST */}
          <Route path="/:slug" element={<IndividualServicePage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
